import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Comment } from 'app/pages/request/request/comment';
import { FileUploadRequest } from 'app/pages/request/request/fileUploadRequest';
import { Request } from 'app/pages/request/request/request';
import { RequestService } from 'app/pages/request/request/request.service';
import { StorageUtils } from '../../../utils/storage-utils';
import { RequestNotificationService } from '../requestNotification/request.service';

@Component({
    selector: 'app-register-user-page',
    templateUrl: './requestNotification-modal.component.html',
    styleUrls: ['./requestNotification-modal.component.scss', '../../../../assets/sass/libs/select.scss'],
    providers: [
        StorageUtils,
        RequestService,
        RequestNotificationService
    ],
    encapsulation: ViewEncapsulation.None
})
export class RequestNotificationPageComponent implements OnInit {

    data: any
    request: Request
    commentText = null
    document: any = null
    file: File = null

    constructor(private router: Router,
        private route: ActivatedRoute,
        public storageUtils: StorageUtils,
        public requestService: RequestService,
        public requestNotificationService: RequestNotificationService,
        public activeModal: NgbActiveModal) {
        this.request = new Request()
    }

    ngOnInit() {
        this.loadRequest()
    }

    save() {
        // if (this.form.valid) {
        //     if (this.storageUtils.getLoggedUser().type === 'CUSTOMER' && this.billing.id == null) {
        //         this.billing.company = new Company()
        //         this.billing.company.id = this.storageUtils.getLoggedUser().idObj
        //     }

        //     this.billing.status = this.statusSelected ? 'ACTIVE' : 'BLOCKED'
        //     this.externalBillingService.save(this.billing, (result) => {

        //         if (result.success) {
        //             swal.fire({
        //                 title: 'Sucesso!',
        //                 text: 'Faturamento externo criado com sucesso',
        //                 icon: 'success',
        //                 showCancelButton: false,
        //                 confirmButtonText: 'Ok',
        //             }).then(() => {
        //                 this.activeModal.close(true)
        //             })
        //         } else {
        //             this.translate.get(result.desc).subscribe((res: string) => {
        //                 swal.fire({
        //                     title: 'Atenção',
        //                     text: res,
        //                     icon: 'error',
        //                     showCancelButton: false,
        //                     confirmButtonText: 'Ok',
        //                 })
        //             });
        //         }
        //     });
        // }
    }
    loadRequest() {
        this.requestService.load(this.data.requestId, (result, request) => {
          
            if (result.success) {
                this.request = request
            }
        })
    }
    addComment() {
        const comment = new Comment()
        comment.description = "Anexo enviado"
        comment.idRequest = this.request.id
        comment.userName = this.storageUtils.getNameUser()
        comment.userId = this.storageUtils.getLoggedUser().id
        comment.userType = this.storageUtils.getLoggedUser().idRole
        if (this.document != null) {
            comment.id = this.document.url.split("/")[4]
            comment.fileUrl = this.document.url
            comment.idDocumentFile = this.document.id
        }
        this.requestService.addComment(comment, (result, resp) => {
            if (resp != null) {
                this.activeModal.close()
            }
        })
    }
    upload(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            this.file = input.files[0];

            const formData = new FileUploadRequest();
            formData.file = this.file
            formData.requestId = this.request.id
            formData.typeUser = this.storageUtils.getLoggedUser().type
            formData.company_id = this.storageUtils.getIdCompany()
            formData.type = this.file.type
            formData.department = "CommentAttachment"
            formData.competence = Date().toString()

            this.requestService.uploadFileComment(formData, (result, resp) => {
                this.document = resp
            })
        }
    }
    toRequest() {
        this.router.navigate(['request/detail/' + this.request.id])
        this.activeModal.close()
    }
}
